//import { useLanguageData } from '@/common/hooks/useLanguageData';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import {
	Wrapper,
	CloseIcon,
	MiddleContentWrappper,
	TopContent,
	WhiteBox,
	Title,
	Description,
	TasksWrapper,
	Task,
	Spacer,
} from './TaskStatusList.styles';
import IconClose from './icons/cross.svg';
import GreenCheckIcon from './icons/green-check.svg';
import GrayCheckIcon from './icons/gray-check.svg';
import { Scene } from '../../types/Scene';

type Props = {
	scene: Scene;
	completedTasks: number[];
	onClose: () => void;
};

const TasksStatusList = ({
	scene,
	completedTasks,
	onClose: closeHandler,
}: Props) => {
	const langData = useLanguageData('features.sceneV3');

	if (!scene.tasks || scene.tasks?.length === 0) return null;

	return (
		<Wrapper>
			<div style={{ flex: 1 }} />
			<WhiteBox>
				<TopContent>
					<div style={{ width: '12px' }} />
					<div />
					<CloseIcon src={IconClose} onClick={closeHandler} />
				</TopContent>
				<MiddleContentWrappper>
					<Title>
						{langData.tasks} {completedTasks?.length}/{scene?.tasks?.length}
					</Title>
					<Description>{scene.description}</Description>
					<TasksWrapper>
						{scene.tasks.map((task, i) => (
							<>
								<Task>
									<img
										src={
											completedTasks.includes(task.id)
												? GreenCheckIcon
												: GrayCheckIcon
										}
									/>
									{task.name}
								</Task>
								{i !== scene.tasks.length - 1 && <Spacer />}
							</>
						))}
					</TasksWrapper>
				</MiddleContentWrappper>
			</WhiteBox>
		</Wrapper>
	);
};

export default TasksStatusList;
